// extracted by mini-css-extract-plugin
export default {"root":"root--uQGTI","content":"content--jybDZ","header":"header--Qar4R"};